"use strict";
var Router = {
    templates:[],
    templateList:[
        "Three hole-in-the-wall resto-bars to celebrate the end of the semester-Liz Willcock.md",
        "Behind the Scenes at McGill Athletics-Morgan Alexander, Mayaz Alam, Elie Waitzer.md",
        "The night owls of CKUT Radio-Audrey Carleton.md",
        "The SSMU that students don't know-Jenna Stanwood.md",
        "A walk through the wallflowers: Exploring McGill's visual arts collection-Chloe Nevitt.md",
        "When users perish, their social media accounts live on-Adrien Hu.md",
        "Simplicity in concept, duplicity in design: The precarious state of daily fantasy sports-Elie Lubendo.md",
        "Establishing a Fall reading week at McGill-Shrinkhala Dawadi.md",
        "The Science and Policy Exchange group is planning for the future-Clare Lyle.md",
        "Biochemist Nahum Sonenberg favours the prepared mind-Chloe Nevitt.md",
        "Up-and-coming fashion trends for students-.md",
        "Discouraged and overlooked, but still competing: A club athlete's experience at McGill-Nicole Spadotto.md",
        "10 Things: Unlikely sports journeys-Nick Jasinski.md",
        "An exchange student's perspective on McGill Students-David Patterson.md",
        "Unlisted: The secret weapon behind Redmen lacrosse-Elie Waitzer.md",
    ],
    load: function(){
        var self = this;
        this.templateList.forEach(function(el, i){
            var author = el.split('-');
            var title = author.slice(0, author.length - 1).join("-")
            author = author[author.length - 1].replace('.md', '');
            self.templates[i] = {
                'author' : author,
                'title' : title,
                'image' : 'media/' + encodeURIComponent(title.replace(/\s/g, '_').replace(/\'/g, '%27').replace(/:/g, '%3A')) + '.jpg',
                'content' : require('views/' + el.replace('.md', ''))
            }
        });
    }
};

module.exports = Router;